import * as React from 'react'
import autobind from 'autobind-decorator';
import { Form, Row, Col, Button } from 'react-bootstrap';
import patchData from 'Utils/PatchData';

interface IProps {
    data: any;
    saveCallback: any;
}


export default class ConceptDocumentEdit extends React.Component<IProps, {}> {
 
    constructor(props: IProps) {
        super(props);
    }

    @autobind
    public onSave(event) {
        event.preventDefault();
        event.stopPropagation();
        let url = `/document/api/page/${this.props.data.content.id}/?format=json`;
        const form = event.currentTarget;
        let data = {
            title: form["title"].value,
            description:form["description"].value
        };
        patchData(url, data)
            .then(response => {
                console.log('response concept doc=>', response);
                this.props.saveCallback();
            })
            .catch(err=>console.log(err));
    }


    public render() {
        return (
            <Form onSubmit={this.onSave}>
                <Form.Group as={Row} controlId="title">
                    <Form.Label column sm={2}>
                        Title
                        </Form.Label>
                    <Col sm={10}>
                        <Form.Control required type="text" defaultValue={this.props.data.content.title} />
                    </Col>
                </Form.Group>

                <Form.Group as={Row} controlId="description">
                    <Form.Label column sm={2}>
                        Description
                        </Form.Label>
                    <Col sm={10}>
                        <Form.Control as="textarea" rows={4} defaultValue={this.props.data.content.description} />
                    </Col>
                </Form.Group>
                <Row>
                    <Col sm={4}>
                        <a href={this.props.data.content.document_file}>
                            <div className="btn btn-link">
                                View Document
                            </div>
                        </a>
                    </Col>
                </Row>
                <Form.Group as={Row}>
                    <Col sm={{ span: 4, offset: 2 }}>
                        <Button variant="success" type="submit">Save</Button>
                    </Col>
                    <Col sm={{ span: 4, offset: 2 }}>
                        <Button variant="warning" type="reset">Revert</Button>
                    </Col>
                </Form.Group>
            </Form>
        );
    }
}